/** Global keyboard navigation shortcuts for page routing and actions. */

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useKeyboardShortcut } from '../../hooks/useKeyboardShortcut'
import { KeyboardShortcutsHelp } from './KeyboardShortcutsHelp'

/**
 * Registers global keyboard shortcuts for navigation:
 * - Ctrl+1: Navigate to Mission Control
 * - ?: Show keyboard shortcuts help
 * - Escape: close modals / deselect (handled by individual components)
 */
export function KeyboardNav() {
  const navigate = useNavigate()
  const [showHelp, setShowHelp] = useState(false)

  // Direct shortcuts with Ctrl modifier for fast navigation
  useKeyboardShortcut({ key: '1', ctrl: true }, () => navigate('/'))

  // ? to show keyboard shortcuts help
  useKeyboardShortcut({ key: '?' }, () => setShowHelp(true))

  return <KeyboardShortcutsHelp open={showHelp} onClose={() => setShowHelp(false)} />
}
